import dayjs from 'dayjs'
import { getEntityName } from '../utils/get-entity-name.js'

export function makeGroupColumn (context, entitiesMap, groupingMethod) {
  console.log('makeGroupColumn', context)

  const groupColumn = {
    headerName: ' ',
    valueGetter: function (cellParams) {
      if (cellParams.data.type === 'break') return null

      if (cellParams.data.type === 'dateGroup') {
        const groupingDateFormat = (groupingMethod === 'byMonth') ? 'MMM YYYY' : 'D MMM YYYY'
        return dayjs(cellParams.data._dateGroup).format(groupingDateFormat)
      }

      if (cellParams.data.type === 'entityPair') {
        const rowTitle = [getEntityName(cellParams.data._entitiesPair[0], entitiesMap), getEntityName(cellParams.data._entitiesPair[1], entitiesMap)].join(' <> ')
        const level = 1

        const padding = ' '.repeat(level * 3) // space is trimmed by AgGrid, could use '\u00A0' instead; or the cellStyle: { whiteSpace: 'pre' }
        return padding + rowTitle
      }

      const level = 2
      const padding = ' '.repeat(level * 3) // space is trimmed by AgGrid, could use '\u00A0' instead; or the cellStyle: { whiteSpace: 'pre' }
      return padding + cellParams.data.transaction?.ledger_date
    },
    colSpan: function (cellParams) {
      if (cellParams.data.type === 'break') return 3
      if (cellParams.data.type === 'date') return 3
      if (cellParams.data.type === 'entityPair') return 3

      return 1
    },
    cellStyle: { whiteSpace: 'pre' },
    pinned: 'left',
    width: 150
  }

  return groupColumn
}
